// SB6-ANA-FILT-05 (D3) — the per-user "Global Data Point Filter Count
// Unit" setting. Read from LysePreferences; written from Settings →
// "Filter Behavior". The filter widget passes the resolved unit to the
// facets query so every bracket count is expressed consistently.
import { useCallback } from "react";
import type { DataPointFilterCountUnit } from "@aeriosiq/types";
import {
  useLysePreferencesQuery,
  useUpdateLysePreferencesMutation,
} from "../preferences/index.js";

export interface UseFilterCountUnitResult {
  countUnit: DataPointFilterCountUnit;
  setCountUnit: (next: DataPointFilterCountUnit) => void;
}

export function useFilterCountUnit(): UseFilterCountUnitResult {
  const { prefs } = useLysePreferencesQuery();
  const { update } = useUpdateLysePreferencesMutation();
  const countUnit: DataPointFilterCountUnit =
    prefs.globalDataPointFilterCountUnit;
  const setCountUnit = useCallback(
    (next: DataPointFilterCountUnit) => {
      update({ globalDataPointFilterCountUnit: next });
    },
    [update],
  );
  return { countUnit, setCountUnit };
}
